/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ResetInputs */

const en_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset to defaults`)
};

const fr_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser les paramètres par défaut`)
};

const de_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Standardeinstellungen zurücksetzen`)
};

const it_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina le impostazioni predefinite`)
};

const ru_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить до значений по умолчанию`)
};

const es_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer valores predeterminados`)
};

const zh_cn2_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复默认设置`)
};

const ja_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初期設定に戻す`)
};

const hi_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिफ़ॉल्ट पर पुनः सेट करें`)
};

const pt_pt2_audio_embed_export_reset = /** @type {(inputs: Audio_Embed_Export_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar padrões de fábrica`)
};

/**
* | output |
* | --- |
* | "Reset to defaults" |
*
* @param {Audio_Embed_Export_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_reset = /** @type {((inputs?: Audio_Embed_Export_ResetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ResetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_reset(inputs)
	if (locale === "de") return de_audio_embed_export_reset(inputs)
	if (locale === "it") return it_audio_embed_export_reset(inputs)
	if (locale === "ru") return ru_audio_embed_export_reset(inputs)
	if (locale === "es") return es_audio_embed_export_reset(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_reset(inputs)
	if (locale === "ja") return ja_audio_embed_export_reset(inputs)
	if (locale === "hi") return hi_audio_embed_export_reset(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_reset(inputs)
	return en_audio_embed_export_reset(inputs)
});